/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 旗舰店首页优惠劵列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.SimpleCouponDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/coupons/shop`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
